// extracted by mini-css-extract-plugin
export default {"card":"page-title_card__vzrCZ","cardHeader":"page-title_cardHeader__g22u-","cardTitle":"page-title_cardTitle__11cet","title":"page-title_title__k2Cx0"};